import './App.css'
import Pages from "@/pages/index.jsx"
import { Toaster } from "@/components/ui/toaster"
import { Toaster as SonnerToaster } from "sonner"
import ErrorBoundary from '@/components/ErrorBoundary.jsx'
import CookieBanner from '@/components/cookies/CookieBanner';
import { ConsentProvider } from '@/components/cookies/ConsentProvider';
import MetaPixelGate from '@/components/marketing/MetaPixelGate';

function App() {
  return (
    <>
      <ConsentProvider>
        <ErrorBoundary>
        <CookieBanner />
        <Pages />
        <MetaPixelGate />
        </ErrorBoundary>
      </ConsentProvider>
      <Toaster />
      <SonnerToaster richColors position="top-right" />
    </>
  )
}

export default App 